export default function formatPrice(price) {
  if (typeof price === "undefined" || isNaN(price)) return "";
  return String(price).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
}